/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const o = {
  vertical: "k-bottom-nav-item-flow-vertical",
  horizontal: "k-bottom-nav-item-flow-horizontal"
}, t = {
  fixed: "k-pos-fixed",
  sticky: "k-pos-sticky"
};
export {
  o as ITEM_FLOW_CLASSES,
  t as POSITION_MODE_CLASSES
};
